import { AlertCircle, RefreshCw } from 'lucide-react'
import { Button } from '@/components/ui/button'
import { PipelineStepper } from './PipelineStepper'
import { TaxonomyRun } from '@/hooks/useTaxonomyRun'

interface ErrorStateProps {
  run: TaxonomyRun
  onRetry: () => void
  isRetrying?: boolean
}

export function ErrorState({ run, onRetry, isRetrying }: ErrorStateProps) {
  // Extract just the first line of the error log (the "Step: xxx" line)
  const errorLines = run.error_log.split('\n')
  const stepLine   = errorLines.find(l => l.startsWith('Step:'))
  const message    = errorLines.find(l => !l.startsWith('Step:') && l.trim()) || 'Unknown error'

  return (
    <div className="w-full">
      {/* Stepper showing the failed step in red */}
      <PipelineStepper progress={run.progress} status="failed" />

      {/* Error detail card */}
      <div className="mt-4 rounded-lg border border-red-200 bg-red-50 p-4">
        <div className="flex items-start gap-2">
          <AlertCircle className="w-5 h-5 text-red-500 mt-0.5 shrink-0" />
          <div className="flex-1 min-w-0">
            <p className="text-sm font-medium text-red-700">
              Pipeline failed {stepLine ? `at ${stepLine.replace('Step: ', '')}` : ''}
            </p>
            <p className="text-xs text-red-600 mt-0.5 truncate" title={message}>
              {message}
            </p>
          </div>
        </div>
      </div>

      {/* Retry button */}
      <div className="mt-4 flex justify-center">
        <Button onClick={onRetry} disabled={isRetrying} variant="outline" className="gap-2">
          <RefreshCw className={`w-4 h-4 ${isRetrying ? 'animate-spin' : ''}`} />
          {isRetrying ? 'Retrying…' : 'Retry Pipeline'}
        </Button>
      </div>
    </div>
  )
}
